import React from 'react';
import { Link } from "react-router-dom";

import GlobalData from '../context/globaldata';

import Chart from 'chart.js';

import Facts from "../components/Facts";
import Header from "../components/Header";

class Dashboard extends React.Component {
  static contextType = GlobalData;

  constructor(props) {
    super(props);
    this.brewFlavourFavorites = React.createRef();
    this.brewAmountChartCanvas = React.createRef();
  }

  createChart(target, data, labels, type) {
    Chart.defaults.global.defaultFontColor = '#FFF';

    const test = this.brewAmountChartCanvas.current.getContext("2d");
    var gradientStroke = test.createLinearGradient(0, 400, 0, 100);
    gradientStroke.addColorStop(0, 'rgba(19, 90, 173, .8)');
    gradientStroke.addColorStop(1, 'rgba(37, 127, 232, .8)');

    if(type === 'line') {
      new Chart(target, {
        type: type,
        data: {
          labels: labels,
          datasets: [{
            data: data,
            backgroundColor: gradientStroke,
            pointBorderWidth: 0,
            pointBorderColor: '#257fe8',
            pointBackgroundColor: '#257fe8',
            pointRadius: 5,
            hoverRadius: 5,
            borderColor: '#257fe8'
          }]
        },
        options: {
          scales: {
            xAxes: [{
              gridLines: {
                display: false
              }
            }],
            yAxes: [{
              gridLines: {
                display: false,
                drawBorder: false
              }
            }]
          },
          responsive: true,
          legend: {
            display: false
          },
          tooltips: false
        }
      });
    }

    if(type === 'radar') {
      new Chart(target, {
        type: type,
        data: {
          labels: labels,
          datasets: [{
            data: data,
            backgroundColor: gradientStroke,
            pointBorderWidth: 0,
            pointBorderColor: '#fff',
            pointBackgroundColor: '#257fe8',
            pointRadius: 5,
            hoverRadius: 5,
            borderColor: '#23304b'
          }]
        },
        options: {

          responsive: true,
          legend: false,
          tooltips: false,
          scale: {
            angleLines: {
              color: '#23304b'
            },
            ticks: {
              fontSize: 0
            },
            gridLines: {
              color: '#23304b'
            }
          }
        }
      });
    }
  }

  componentDidMount() {
    this.createChart(this.brewFlavourFavorites.current, [5, 11, 16, 10, 14, 9, 12], ['Sweet','Smokey','Green','Berry','Fruit','Floral','Dried Fruit'], 'radar');
    this.createChart(this.brewAmountChartCanvas.current, [4, 4, 3, 8, 14, 38, 23], ['12-08-2019','13-08-2019','14-08-2019','15-08-2019','16-08-2019','17-08-2019','18-08-2019'], 'line');
  }

  componentWillUnmount() {
    if(this.hasOwnProperty('databaseSnapshot')) {
      this.databaseSnapshot();
    }
  }

  render() {
    return (
      <div className="dashboard">
        <Header title="Dashboard"/>
        <div className="dashboard__background">
          <div className="dashboard__background-chart">
            <canvas height="80px" ref={ this.brewAmountChartCanvas }></canvas>
          </div>
        </div>
        <div className="dashboard__container">
          <div className="dashboard__blocks">
            <div className="dashboard__block dashboard__block--medium">
              <h2>Welcome back { this.context.currentUser.displayName }!</h2>
              <p>Last time you logged in was: <strong>{ this.context.currentUser.metadata.lastSignInTime }</strong></p>
              <p>You've logged <strong>{ this.context.brewAmountTotal }</strong> brews in total, let's <Link to="/brews/add">add { this.context.brewAmountTotal > 0 && 'another ' }one</Link>.</p>
            </div>
            <div className="dashboard__block dashboard__block--medium">
              <h2>Favorite flavours</h2>
              <canvas height="180px" ref={ this.brewFlavourFavorites }></canvas>
            </div>
            <Facts />
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;
